import React, { useEffect, useState } from "react"
import { Container, Row, Col } from "reactstrap"
import { Link } from "react-router-dom"
import CPSRequestsList from "./CPSRequestsList"
import Breadcrumbs from "components/Common/Breadcrumb"
import { GetAllCPSRequests, GetMyUser } from "helpers/backend_helper"
import { useLoading } from "helpers/custom_hooks"
import { IsCPSModuleEnabled } from "helpers/misc_helpers"

const CPSRequests = () => {
  const [cpsRequests, setCPSRequests] = useState([])
  const [myUser, setMyUser] = useState()
  const [loading, setLoading] = useState(true)
  const [isCPSEnabled, setIsCPSEnabled] = useState(undefined)
  const [dataLoaded, setDataLoaded] = useState(false)
  const setGlobalLoading = useLoading()

  const loadData = async () => {
    setLoading(true)
    setGlobalLoading(true)
    try {
      const [requests, user, enabled] = await Promise.all([
        GetAllCPSRequests(),
        GetMyUser(),
        IsCPSModuleEnabled(),
      ])

      setIsCPSEnabled(enabled)

      // Transform API data to match frontend expectations
      const transformedRequests = requests
        .map(request => ({
          ...request,
          // Map API fields to frontend expectations
          customer: {
            name: request.requestor?.name || "Unknown Customer",
            contact: request.username || "Unknown Contact",
          },
          quantityType: request.needType === "one-time" ? "onetime" : "annual",
          status: mapStatusIndex(request.statusIndex),
          statusIndex: request.statusIndex,
          dateUpdated: request.dateUpdated,
          estimatedCompletion: request.desiredDeliveryDate,
          safetyStock:
            request.safetyStockMin && request.safetyStockMax
              ? {
                  min: request.safetyStockMin,
                  max: request.safetyStockMax,
                  current: Math.floor(
                    (request.safetyStockMin + request.safetyStockMax) / 2
                  ), // Mock current value
                }
              : null,
          customerSupplies: request.customerSupply === 1,
          isParentRequest: request.isParentRequest === 1,
          files: [], // Not in API yet
          subRequests: [], // Not in API yet
        }))
        // Sort by createdAt descending (newest first)
        .sort((a, b) => new Date(b.dateCreated) - new Date(a.dateCreated))

      setCPSRequests(transformedRequests)
      setMyUser(user)
      setDataLoaded(true)
    } catch (error) {
      console.error("Error loading CPS requests:", error)
      setCPSRequests([])
      setDataLoaded(true)
    }
    setLoading(false)
    setGlobalLoading(false)
  }

  // Map status index to status string
  const mapStatusIndex = statusIndex => {
    const statusMap = {
      1: "Request Created",
      2: "CPS Offer",
      3: "Customer Decision",
      4: "Goods Shipped",
      5: "Goods Received",
      6: "Sample Production",
      7: "Sample Approval",
      8: "Production",
      9: "Production",
      10: "Completed",
      99: "Cancelled",
    }
    return statusMap[statusIndex] || "Unknown"
  }

  useEffect(() => {
    loadData()
  }, [])

  useEffect(() => {
    if (dataLoaded && isCPSEnabled != undefined) setLoading(false)
  }, [dataLoaded, isCPSEnabled])

  if (loading) {
    return (
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="CPS" breadcrumbItem="Programming Requests" />
          <div className="text-center">
            <div className="spinner-border" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        </Container>
      </div>
    )
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {isCPSEnabled ? (
            <>
              <Breadcrumbs title="CPS" breadcrumbItem="Programming Requests" />
              <Row>
                <Col lg="12">
                  <CPSRequestsList entries={cpsRequests} myUser={myUser} />
                </Col>
              </Row>
            </>
          ) : (
            <Row>
              <Col lg="12">
                <div className="text-center mb-5">
                  <h1 className="display-2 fw-medium">
                    4<i className="bx bx-buoy bx-spin text-primary display-3" />
                    3
                  </h1>
                  <h4 className="text-uppercase">
                    Sorry, you are not allowed to view this page
                  </h4>
                  <p className="text-primary">
                    This is a premium feature. To use this feature, please
                    upgrade your license!
                  </p>
                  <div className="mt-5 text-center">
                    <Link
                      className="btn btn-primary waves-effect waves-light "
                      to="/settings?tab=2"
                    >
                      Upgrade Account
                    </Link>
                    <br />
                    <Link className=" d-block mt-4" to="/dashboard">
                      <i className="bx bx-left-arrow-alt" />
                      Back to Dashboard
                    </Link>
                  </div>
                </div>
              </Col>
            </Row>
          )}
        </Container>
      </div>
    </React.Fragment>
  )
}

export default CPSRequests
